var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f5c92243-6f6e-4606-9e7f-3231d992a41b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.2754,
    height: 112.3278,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 111.2754 112.3278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-23042445-ecaf-4850-bfd1-69e7a68c0f67{fill:url(#uuid-da871d8a-3b95-46e8-aea1-35dd7b95d013);}.uuid-d556778e-7669-4664-b3d4-c183a5d60bc0{fill:url(#uuid-cc04595e-b87d-497d-80fd-9bea7f652f3b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-cc04595e-b87d-497d-80fd-9bea7f652f3b",
    x1: 1434.2727,
    y1: 1740.7497,
    x2: 1543.289,
    y2: 1834.5436,
    gradientTransform: "translate(-809.4044 -985.559) scale(.5625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a9fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-da871d8a-3b95-46e8-aea1-35dd7b95d013",
    x1: 1585.4493,
    y1: 1891.3166,
    x2: 1546.5196,
    y2: 1836.2378,
    gradientTransform: "translate(-809.4044 -985.559) scale(.5625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd43b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe873"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-b795f1c4-d0d0-40ac-92a9-258d32c80afd",
    className: "uuid-d556778e-7669-4664-b3d4-c183a5d60bc0",
    d: "M55.0127,0c-4.6,0-9,.4-12.8,1.1-11.3,2-13.4,6.2-13.4,13.9v10.2h26.8v3.4H18.7127c-7.8,0-14.6,4.7-16.8,13.6-2.5,10.2-2.6,16.6,0,27.2,1.9,7.9,6.5,13.6,14.2,13.6h9.2v-12.2c0-8.8,7.7-16.7,16.8-16.7h26.8c7.5,0,13.4-6.1,13.4-13.6V15c0-7.3-6.1-12.7-13.4-13.9-4.5-.8-9.3-1.1-13.9-1.1Zm-14.5,8.2c2.8,0,5,2.3,5,5.1s-2.3,5.1-5,5.1c-2.8,0-5-2.3-5-5.1s2.2-5.1,5-5.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-01dbf838-81e1-48ac-b091-1d566d4127a3",
    className: "uuid-23042445-ecaf-4850-bfd1-69e7a68c0f67",
    d: "M85.7127,28.7v11.9c0,9.2-7.8,17-16.8,17h-26.7c-7.3,0-13.4,6.3-13.4,13.6v25.5c0,7.3,6.3,11.5,13.4,13.6,8.5,2.5,16.6,2.9,26.8,0,6.8-2,13.4-5.9,13.4-13.6v-10.2h-26.8v-3.4h40.2c7.8,0,10.7-5.4,13.4-13.6,2.8-8.4,2.7-16.5,0-27.2-1.9-7.8-5.6-13.6-13.4-13.6h-10.1Zm-15,64.6c2.8,0,5,2.3,5,5.1s-2.3,5.1-5,5.1c-2.8,0-5-2.3-5-5.1-.1-2.8,2.2-5.1,5-5.1Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.d470d57fd15c2169c8856f48ec330d68.svg";
export { ForwardRef as ReactComponent };